<template>
  <hcc-modal
    class="close-modal"
    :title="title"
    name="close-conversation-modal"
    @confirm="onConfirm"
    @opened="onOpen"
    @closed="onClose"
    :confirmDisableButton="!isValid"
  >
    <div class="close-modal--body">
      <hcc-select
        :label="$t('cancel-modal.category')"
        ref="categoryList"
        class="close-modal--element"
        custom-class="expanded"
        :options="categories"
        :option-label="'name'"
        :track-by="'id'"
        :requiredInput="true"
        v-model="selectedCategory"
      />
      <hcc-select
        v-if="showSubcategories"
        :multiple="true"
        :label="$t('cancel-modal.sub-category')"
        class="close-modal--element"
        custom-class="expanded"
        :options="subcategories"
        :option-label="'name'"
        :track-by="'id'"
        v-model="selectedSubcategory"
        :allow-empty="true"
        :close-on-select="true"
        :limit="1"
      />
      <hcc-textarea
        :label="$t('cancel-modal.comments')"
        class="close-modal--element"
        name="tx-commentary"
        :rows="8"
        v-model.trim="commentary"
      />
    </div>
  </hcc-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import HccModal from '@/components/shared/HccModal/index.vue';
import HccSelect from '@/components/shared/HccSelect/index.vue';
import HccTextarea from '@/components/shared/HccTextarea/index.vue';

export default {
  components: {
    HccModal,
    HccSelect,
    HccTextarea,
  },
  props: {
    campaignId: {
      required: true,
      type: String,
    },
    conversationId: {
      required: true,
      type: String,
    },
    action: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      commentary: '',
      selectedCategory: null,
      selectedSubcategory: [],
    };
  },
  computed: {
    ...mapGetters([
      'getAllCategories',
    ]),
    categories() {
      return this.getAllCategories(this.campaignId).filter((c) => c.type === 'Category');
    },
    subcategories() {
      if (this.selectedCategory !== null) {
        const subcategorie = this.getAllCategories(this.campaignId)
          .filter(({ type, parent }) => (type === 'Subcategory' && parent == null)
            || (type === 'Subcategory' && parent === this.selectedCategory.id));
        return subcategorie;
      }
      return [];
    },
    showSubcategories() {
      return this.subcategories.length > 0;
    },
    actionLabel() {
      switch (this.action) {
        case 'cancel':
          return 'Cancel';
        case 'finish':
          return 'Finish';
        default:
          return '';
      }
    },
    actionId() {
      switch (this.action) {
        case 'cancel':
          return 'CLOSED';
        case 'finish':
          return 'FINISHED';
        default:
          return '';
      }
    },
    title() {
      return this.actionLabel === 'Cancel' ? this.$t('cancel-modal.title') : this.$t('cancel-modal.finish');
    },
    isValid() {
      return this.selectedCategory !== null;
    },
    history() {
      const status = {
        key: 'closed',
        name: 'Cancelada',
      };
      if (this.actionId === 'FINISHED') {
        status.key = 'finished';
        status.name = 'Resuelta';
      }
      const history = {
        status,
        tags: [{
          name: this.selectedCategory.name,
          typeTag: this.selectedCategory.type,
        }],
        campaign: { name: '' },
        agent: { name: '' },
        lastMessageAt: this.$moment().format().toString(),
      };
      if (this.selectedSubcategory) {
        history.tags.push({
          name: this.selectedSubcategory.name,
          typeTag: 'Subcategory',
        });
      }
      return history;
    },
  },
  watch: {
    selectedCategory() {
      this.selectedSubcategory = [];
    },
  },
  methods: {
    async onOpen() {
      await this.$nextTick(() => this.$refs.categoryList.focus());
    },
    onClose() {
      this.commentary = '';
      this.selectedCategory = null;
    },
    onConfirm() {
      const categoryId = this.selectedCategory
        ? this.selectedCategory.id
        : null;

      const subcategoryId = this.selectedSubcategory.length > 0
        ? this.selectedSubcategory.map(({ id }) => id)
        : null;

      const payload = {
        action: this.actionId,
        conversationId: this.conversationId,
        categoryId,
        subcategoryId,
        comments: this.commentary,
      };
      this.$emit('confirm', { payload, history: this.history });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v--modal-overlay .v--modal-box {
  overflow: visible;
}

::v-deep .vm--modal {
  overflow: unset !important;
}

</style>
